<template>
  <div
    v-show="isShow"
    class="guidance"
  >
    <div
      class="guidance-mask"
      :style="{ left: step === 4 ? '197px' : '0px' }"
    ></div>
    <div
      v-for="(t, i) in tips"
      v-show="step == i"
      :key="i"
      class="guidance-box"
      :style="t.boxStyle"
    >
      <div
        v-if="i == 0"
        class="box-button first-button"
      >
        <iconfont
          name="#icon10-10tianjiashipin"
          font-size="48px"
        ></iconfont>
      </div>
      <div
        v-if="i == 1"
        class="box-button second-button"
      >
        <div class="box-button-title">
          {{ t.button.text }}
        </div>
        <div class="box-button-content">
          <span>视频片段1</span>
        </div>
      </div>
      <div
        v-if="i == 2"
        class="box-button three-button"
      >
        完成
      </div>
      <div
        v-if="i == 3"
        class="box-button four-button"
      >
        怎么操作?
      </div>
      <!-- 线条 -->
      <div
        class="box-line"
        :style="{
          width: t.tip.w + 'px',
          height: t.tip.h + 'px',
          top: t.tip.y + 'px',
          left: t.tip.x + 'px',
          backgroundImage: `url(/toolkit/img/guidance/guidance-line-0${i}.svg)`
        }"
      ></div>
      <!-- 下一步 -->
      <div
        class="box-content"
        :style="{
          width: t.content.w + 'px',
          height: t.content.h + 'px',
          top: t.content.y + 'px',
          left: t.content.x + 'px'
        }"
      >
        <p v-html="t.content.text"></p>
        <div class="box-content-btn">
          <span
            v-if="i > 1 && i != 4"
            @click="skip"
          >跳过</span>
          <div @click="next">
            {{ i != 4 ? '下一步' : '开始制作' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      isShow: false,
      step: 0,
      tips: [
        {
          boxStyle: null,
          button: {
            x: 0,
            y: 0,
            w: 48,
            h: 48
          },
          tip: {
            x: 26,
            y: -58,
            w: 103,
            h: 52
          },
          content: {
            x: 141,
            y: -104,
            w: 276,
            h: 121,
            text: '点击选取上传视频或直接将视频拖拽至此处。'
          }
        },
        {
          boxStyle: null,
          button: {
            x: 0,
            y: 97,
            w: 326,
            h: 0,
            text: '剪辑列表'
          },
          tip: {
            x: -97,
            y: 116,
            w: 85,
            h: 78
          },
          content: {
            x: -300,
            y: 208,
            w: 276,
            h: 121,
            text: '完成处理的作品会展示在此处，支持预览和删除哦。'
          }
        },
        {
          boxStyle: {
            width: '120px',
            height: '40px',
            top: '20px',
            right: '33px'
          },
          button: {
            x: 20,
            y: 33,
            w: 120,
            h: 40,
            text: '完成'
          },
          tip: {
            x: -15,
            y: 48,
            w: 89,
            h: 72
          },
          content: {
            x: -206,
            y: 130,
            w: 276,
            h: 121,
            text: '视频处理完毕，点击“完成”即可进入下载。'
          }
        },
        {
          button: {
            x: 0,
            y: 0,
            w: 74,
            h: 20
          },
          tip: {
            x: 42,
            y: 32,
            w: 89,
            h: 72
          },
          content: {
            x: -7,
            y: 117,
            w: 276,
            h: 121,
            text: '工具使用遇难题，可在此处查看操作指南。'
          }
        },
        {
          boxStyle: {
            width: '0px',
            height: '0px',
            top: '98px',
            left: '197px'
          },
          button: {
            x: 197,
            y: 98,
            w: 0,
            h: 0
          },
          tip: {
            x: 10,
            y: 37,
            w: 89,
            h: 72
          },
          content: {
            x: 51,
            y: 126,
            w: 276,
            h: 159,
            text: '在这里快速切换使用其他工具。工具切换将不会保留原有工具的处理成果，请留意。<br>祝使用愉快！'
          }
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      views: 'views/dict'
    })
  },
  mounted() {
    if (!localStorage.getItem('hasUseToolkit')) {
      this.isShow = true;
      this.$nextTick(() => {
        this.getFirst();
        this.getSecond();
        this.getFour();
      });
    }
    window.addEventListener('resize', () => {
      if (this.isShow) {
        this.getFirst();
        this.getSecond();
        this.getFour();
      }
    });
  },
  methods: {
    async getFirst() {
      let dom = document.getElementsByClassName('add-video-guidance')[0];
      if (!dom) {
        await this.sleep(200);
        dom = document.getElementsByClassName('add-video-guidance')[0];
      }
      let { top: y, left: x } = dom.getBoundingClientRect();
      let m = this.tips[0].button;
      m.x = x;
      m.y = y;
      this.tips[0].boxStyle = {
        width: m.w + 'px',
        height: m.h + 'px',
        left: m.x + 'px',
        top: m.y + 'px'
      };
    },
    getSecond() {
      let dom = document.getElementsByClassName('comp-rightpanel')[0];
      let m = this.tips[1].button;
      let text = (this.views[this.$route.path.slice(1)] || {}).text;
      if (text) text = text.slice(0, -1);
      if (!text) {
        m.text = '剪辑列表';
      } else if (text === 'GIF') {
        m.text = 'GIF图列表';
      } else {
        m.text = text + '列表';
      }
      m.h = dom.clientHeight;
      this.tips[1].boxStyle = {
        width: m.w + 'px',
        height: m.h + 'px',
        top: m.y + 'px',
        right: m.x + 'px'
      };
    },
    getFour() {
      let dom = document.querySelector('.comp-commonheader .part-1 .how');
      let { top: y, left: x } = dom.getBoundingClientRect();
      let m = this.tips[3].button;
      m.x = x;
      m.y = y;
      this.tips[3].boxStyle = {
        width: m.w + 'px',
        height: m.h + 'px',
        left: m.x + 'px',
        top: m.y + 'px'
      };
    },
    next() {
      this.step++;
      if (this.step === 5) {
        this.isShow = false;
        localStorage.setItem('hasUseToolkit', true);
        this.$bus.emit('hasUseToolkit');
      }
    },
    skip() {
      this.isShow = false;
      localStorage.setItem('hasUseToolkit', true);
      this.$bus.emit('hasUseToolkit');
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }
  }
};
</script>
<style lang="scss" scoped>
.guidance {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 99;

  .guidance-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }

  .guidance-box {
    position: absolute;
  }

  .box-button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  .first-button {
    color: #2f58fe;
    border-radius: 9px;
  }
  .second-button {
    border-radius: 4px;
    height: calc(100% - 17px);

    .box-button-title {
      width: 100%;
      height: 69px;
      padding: 30px 0px 23px 33px;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
    }

    .box-button-content {
      width: 260px;
      height: 147px;
      margin: 0 auto;
      background-image: url(/toolkit/img/guidance/guidance-list-pic.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;

      span {
        position: relative;
        top: 105%;
        left: 0;
        width: 100%;
        display: block;
        text-align: center;
      }
    }
  }
  .three-button {
    line-height: 40px;
    background: #2f58fe;
    border-radius: 4px;
    color: #ffffff;
  }
  .four-button {
    background: #f6f7fb;
    border: 1px solid #2f58fe;
    border-radius: 10px;
    font-size: 12px;
    color: #2f58fe;
    line-height: 20px;
  }

  .box-line {
    position: absolute;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .box-content {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 19px 21px;
    border-radius: 4px;

    p {
      text-align: left;
      color: #333333;
      font-size: 14px;
      text-align: justify;
      line-height: 22px;
    }

    .box-content-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 12px;
      font-weight: 400;

      span {
        color: #9a9a9a;
        cursor: pointer;
      }

      div {
        padding: 5px 7px 4px;
        text-align: center;
        color: #ffffff;
        background: #3058fe;
        border-radius: 11px;
        cursor: pointer;
        margin-left: 4px;
      }
    }
  }
}
</style>
